export default __webpack_public_path__ + "static/media/Authentication.43f6972f.svg";